import React, { FC, Fragment, useEffect, useState } from "react";
import ApiSpinner from "../../common/ApiSpinner";
import clsx from "clsx";
import SofIcon from "../../common/Icons";
import queryString from "query-string";
import { connect } from "react-redux";
import { last6Digits, toNominationNo } from "../../../services/Helper";
import { mergeStyles } from "@fluentui/react";
import { mergeStyleSets } from "@fluentui/react";
import { Persona } from "@fluentui/react";
import { PersonaSize } from "@fluentui/react";
import { pushNotification } from "../../../api/pushNotification";
import { State } from "../../../store";
import { NavLink, useHistory, useParams } from "react-router-dom";
import { Nomination, SofView, TruckNomination } from "../../../models";
import * as ActivityLogStore from "../../../store/ActivityLogsStore";
import * as GeneralStore from "../../../store/GeneralStore";
import * as TruckNominationStore from "../../../store/TruckNominationStore";
import * as OfflineDataStore from "../../../store/OfflineDataStore";
import * as SofViewStore from "../../../store/SofViewStore";
import WorkPacket from "../../dwp/WorkPacketList";
import AdditionalServices from "../../dwp/AdditionalServices";
import * as ProcessFlowConfigStore from "../../../store/ProcessFlowConfigStore";
import { Account } from "react-aad-msal";
import UndoModal from "../UndoModal";
import NominationPanel from "./NominationPanel";
import RejectLineHandlingModal from "../../sof/RejectLineHandlingModal";
import RemarksPane from "../../sof/RemarksPane";
import NominationTile from "../../sof/NominationTile";
import DeleteActivitiesModal from "../../sof/DeleteActivitiesModal";
import NoDataPane from "../../sof/NoDataPane";
import StatusBar from "../StatusBar";
import TruckNominationHeader from "../TruckNominationHeader";
import * as LineHandlingStore from "../../../store/LineHandlingStore";
import * as WorkPacketStore from "../../../store/WorkPacketStore";
import AttachmentModal from "../AttachmentModal";
import NominationDetailModal from "../NominationDetailModal";

interface ParentCompProps {
  children?: React.ReactNode;
}

type Props = ActivityLogStore.ActivityLogsState &
  GeneralStore.GeneralState &
  TruckNominationStore.TruckNominationState &
  ProcessFlowConfigStore.ProcessFlowConfigState &
  OfflineDataStore.OfflineDataState &
  SofViewStore.SofViewState &
  WorkPacketStore.WorkPacketState &
  LineHandlingStore.LineHandlingState &
  typeof ActivityLogStore.actionCreators &
  typeof TruckNominationStore.actionCreators &
  typeof OfflineDataStore.actionCreators &
  typeof ProcessFlowConfigStore.actionCreators &
  typeof SofViewStore.actionCreators &
  typeof SofViewStore.actionCreators & {
    account: Account;
  } & typeof GeneralStore.actionCreators &
  typeof WorkPacketStore.actionCreators &
  typeof LineHandlingStore.actionCreators &
  ParentCompProps;

const panelRow = mergeStyles({
  display: "flex",
});
const headerTitle = mergeStyles({
  letterSpacing: "0.004em",
});
const buttonBase = mergeStyles({
  padding: "9px 10px",
  fontSize: 16,
  fontWeight: 500,
  height: 42,
  border: "none",
  color: "#4c4c4c",
  selectors: {
    [":active"]: {
      backgroundColor: "#008cc0",
    },
  },
});
const classes = mergeStyleSets({
  leftPane: [
    panelRow,
    {
      flexDirection: "column",
      height: "100%",
      margin: "8px 12px 0",
      overflow: "hidden",
    },
  ],
  leftPane2: [
    panelRow,
    {
      flexDirection: "column",
      margin: "8px 12px 0",
      height: "100%",
      overflow: "hidden",
    },
  ],
  headerRow: [
    panelRow,
    {
      alignItems: "center",
      padding: "6px 24px",
      background: "white",
      borderBottom: "1px solid #E2E6E8",
    },
  ],
  headerRowTextPane: [
    panelRow,
    {
      flexDirection: "column",
      flexGrow: 1,
      margin: "0 10px",
      paddingLeft: 10,
      borderLeft: "1px solid #E2E6E8",
    },
  ],
  headerTitle: [
    headerTitle,
    {
      fontSize: 16,
      lineHeight: "20px",
      fontWeight: "bold",
    },
  ],
  headerSubTitle: [
    headerTitle,
    {
      fontSize: 12,
      lineHeight: "14px",
    },
  ],
  iconColor: {
    color: "#000",
  },
  contextMenuButton: {
    height: 32,
    width: 32,
    color: "#000",
    display: "block",
    textAlign: "center",
    fontSize: "24px",
    fontWeight: "bold",
    lineHeight: "12px",
  },
  buttonIcon: {
    marginRight: 2,
    padding: "9px 10px",
    fontSize: 16,
    fontWeight: 500,
    height: 40,
    width: 40,
    justifyContent: "center",
    border: "1px solid #D8DFE6",
    borderRadius: "2px",
    display: "flex",
    alignItems: "center",
    color: "#4c4c4c",
    selectors: {
      [":active"]: {
        backgroundColor: "#008cc0",
      },
    },
  },
  button: [buttonBase],
});

const NominationHandlingPane: FC<Props> = (props: Props) => {
  const { truckNomination, children, isVerifyInformationModal } = props;
  let param = useParams() as any;
  const nominationNo = param.lineHandlingNo;
  //const [lineHandlingNo, setLineHandlingNo] = useState<string>();
  const [isApproved, setIsApproved] = useState(false);
  // const [nomination, setNomination] = useState<TruckNomination>();

  const [selTransferType, setSelTransferType] = useState("Loading");
  const history = useHistory();
  const navRef = React.createRef<any>();
  const transferTypes: { [key: string]: string } = {
    ["Loading"]: "Loading",
    ["Special"]: "Special INSTR.",
  };
  const deleteActivitiesEnv: string[] = [
    "-dev",
    "-uat",
    "-sandbox",
    "localhost",
  ];
  const startTransferSteps: number[] = [
    42, 65, 97, 120, 141, 142, 155, 156, 174, 175, 188, 189,
  ];

  const onTransferTypeChange = (transferType: string) => {
    setSelTransferType(transferType);

    if (props.truckNomination.result) {
      const activeTransferType =
        props.truckNomination.result &&
        props.truckNomination.result.transferType === transferType;

      if (activeTransferType) {
        setSelTransferType(transferType);
      }
    }
  };

  const onRefresh = () => {
    const { search } = history.location;
    const q = queryString.parse(search.toLowerCase());
    const linehandlingno = q.linehandling as string;
    const nominationno = q.nomination as string | undefined;

    props.getActivityLogs(nominationNo, () => {
      props.getTruckNomination(nominationNo, false, false);
    });
  };

  const onNominationEdit = (nom: TruckNomination) => {
    const { truckNomination } = props;
    if (truckNomination.result) {
      props.setTruckNomination(nom);
    }
  };

  // useEffect(() => {
  //   if (truckNomination && truckNomination.result) {
  //     setNomination(truckNomination.result);
  //   }
  // }, [truckNomination]);

  return (
    <Fragment>
      <div
        className=""
        style={{
          background: "#ffffff",
          borderBottom: "1px solid #ededed",
          zIndex: 2,
        }}
      >
        <div className={classes.headerRow}>
          {truckNomination.result?.transferType === "Tank to Truck" ||
          truckNomination.result?.transferType === "Tank to Rail Car" ? (
            <Fragment>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="arrow_back">
                  <mask
                    id="mask0_6_1855"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                  >
                    <rect
                      id="Bounding box"
                      width="24"
                      height="24"
                      fill="#D9D9D9"
                    />
                  </mask>
                  <g mask="url(#mask0_6_1855)">
                    <path
                      id="arrow_back_2"
                      d="M7.37302 12.75L13.0692 18.4461L12 19.5L4.5 12L12 4.5L13.0692 5.55383L7.37302 11.25H19.5V12.75H7.37302Z"
                      fill="#1C1B1F"
                    />
                  </g>
                </g>
              </svg>
            </Fragment>
          ) : (
            <Fragment>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="arrow_forward">
                  <mask
                    id="mask0_6_1843"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                  >
                    <rect
                      id="Bounding box"
                      width="24"
                      height="24"
                      fill="#D9D9D9"
                    />
                  </mask>
                  <g mask="url(#mask0_6_1843)">
                    <path
                      id="arrow_forward_2"
                      d="M16.6269 12.75H4.5V11.25H16.6269L10.9308 5.55383L12 4.5L19.5 12L12 19.5L10.9308 18.4461L16.6269 12.75Z"
                      fill="#1C1B1F"
                    />
                  </g>
                </g>
              </svg>
            </Fragment>
          )}

          <div className={classes.headerRowTextPane}>
            <span className={classes.headerTitle}>
              {toNominationNo(nominationNo)}
            </span>
          </div>
          <div className="d-flex" style={{ gap: "16px" }}>
            {/* {(props?.truckNomination.result?.status ?? 0) < 2 &&
              props.isTruckEditActivityAllowed && (
                <div>
                  <div
                    style={{
                      textAlign: "center",
                      display: "flex",
                      alignItems: "center",
                      flexDirection: "column"
                    }}
                    onClick={() => props.checkSofViewRejection(true)}
                  >
                    <div
                      style={{
                        height: 48,
                        width: 48,
                        padding: 12,
                        borderRadius: "50%",
                        background: "#F3F4F6",
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        viewBox="0 -960 960 960"
                        width="24"
                        fill="#DC2626"
                      >
                        <path d="M480-281q14 0 24.5-10.5T515-316q0-14-10.5-24.5T480-351q-14 0-24.5 10.5T445-316q0 14 10.5 24.5T480-281Zm-30-144h60v-263h-60v263ZM330-120 120-330v-300l210-210h300l210 210v300L630-120H330Zm25-60h250l175-175v-250L605-780H355L180-605v250l175 175Zm125-300Z" />
                      </svg>
                    </div>
                  </div>
                  <div
                    style={{
                      fontSize: 12,
                      textAlign: "center",
                    }}
                  >
                    Rejected
                  </div>
                </div>
              )} */}
            <AttachmentModal />
            <NominationDetailModal />
            <UndoModal />
          </div>
        </div>
      </div>
      <TruckNominationHeader {...props} />
      <Fragment>
        <div
          style={{
            margin: "8px 12px 0px 12px",
          }}
        >
          <StatusBar className="" {...props} />
        </div>

        <div className={classes.leftPane}>
          <div
            className="d-flex w-100 h-100"
            style={{
              gap: "16px",
              justifyContent: "center",
            }}
          >
            {/*<div*/}
            {/*  style={{*/}
            {/*    width: "35%",*/}
            {/*    background: "white",*/}
            {/*    padding: "16px",*/}
            {/*    display: "flex",*/}
            {/*    flexDirection: "column",*/}
            {/*    zIndex: isVerifyInformationModal ? 999 : 1*/}
            {/*  }}*/}
            {/*>*/}
            {/*  */}
            {/* TRANSFER TYPES */}
            {/*  {props.sofView !== SofView.LineHandling && (*/}
            {/*    <div className="ms-Grid-row">*/}
            {/*      <div className="ms-Grid-col ms-sm12 btn-menu-group">*/}
            {/*        {Object.keys(transferTypes).map((key) => {*/}
            {/*          const btnClass = clsx(*/}
            {/*            `btn-menu`,*/}
            {/*            key === selTransferType && " btn-menu-selected"*/}
            {/*          );*/}

            {/*          return (*/}
            {/*            <div*/}
            {/*              key={key}*/}
            {/*              id={`btn-transfer-type-${transferTypes[key]}`}*/}
            {/*              className={btnClass}*/}
            {/*              style={{*/}
            {/*                textAlign: "center",*/}
            {/*                justifyContent: "space-between",*/}
            {/*                alignItems: "center"*/}
            {/*              }}*/}
            {/*              onClick={() => onTransferTypeChange(key)}*/}
            {/*            >*/}
            {/*              {transferTypes[key] === "Loading" ? (*/}
            {/*                <Fragment>*/}
            {/*                  {truckNomination.result?.nominationType ===*/}
            {/*                  "Load" ? (*/}
            {/*                    <Fragment>Loading</Fragment>*/}
            {/*                  ) : truckNomination.result?.nominationType ===*/}
            {/*                    "Discharge" ? (*/}
            {/*                    <Fragment>Offloading</Fragment>*/}
            {/*                  ) : (*/}
            {/*                    props.truckNomination.result?.transferType*/}
            {/*                  )}*/}
            {/*                </Fragment>*/}
            {/*              ) : (*/}
            {/*                transferTypes[key]*/}
            {/*              )}*/}

            {/*              */}
            {/* {transferTypes[key] === "Loading"*/}
            {/*
             */}
            {/*                ? props.truckNomination.result?.transferType*/}
            {/*
             */}
            {/*                : transferTypes[key]} */}
            {/*              */}
            {/* {activeTransferType &&*/}
            {/*
             */}
            {/*                props.truckNomination.result && (*/}
            {/*
             */}
            {/*                  <Persona*/}
            {/*
             */}
            {/*                    size={PersonaSize.size24}*/}
            {/*
             */}
            {/*                    initialsColor={*/}
            {/*
             */}
            {/*                      key == selTransferType ? "#FFF" : "#4C4C4C"*/}
            {/*
             */}
            {/*                    }*/}
            {/*
             */}
            {/*                    color={key == selTransferType ? "#000" : "#FFF"}*/}
            {/*
             */}
            {/*                    imageInitials="1"*/}
            {/*
             */}
            {/*                    style={{ margin: 0 }}*/}
            {/*
             */}
            {/*                  />*/}
            {/*
             */}
            {/*                )} */}
            {/*            </div>*/}
            {/*          );*/}
            {/*        })}*/}
            {/*      </div>*/}
            {/*    </div>*/}
            {/*  )}*/}

            {/*  {(props.sofView === SofView.Nomination ||*/}
            {/*    props.sofView === SofView.NominationEdit) &&*/}
            {/*    truckNomination.result && (*/}
            {/*      <NominationPanel*/}
            {/*        lineHandlingStatus={truckNomination.result.status}*/}
            {/*        isLineHandlingRejected={truckNomination.result.isRejected}*/}
            {/*        nomination={truckNomination.result}*/}
            {/*        isEditActivityAllowed={props.isTruckEditActivityAllowed}*/}
            {/*        isAddCommentAllowed={props.isTruckAddCommentAllowed}*/}
            {/*        isDeleteCommentAllowed={props.isTruckDeleteCommentAllowed}*/}
            {/*        isOffline={props.isOffline}*/}
            {/*        isApproved={isApproved}*/}
            {/*        onNominationEditStart={() =>*/}
            {/*          props.setSofView(SofView.NominationEdit)*/}
            {/*        }*/}
            {/*        onNominationEditEnd={() =>*/}
            {/*          props.setSofView(SofView.Nomination)*/}
            {/*        }*/}
            {/*        onNominationEdit={onNominationEdit}*/}
            {/*        setTruckNomination={props.setTruckNomination}*/}
            {/*        activityLog={props.activityLogs}*/}
            {/*        selTransferType={selTransferType}*/}
            {/*        isVerifyInformationModal={isVerifyInformationModal}*/}
            {/*        isApproveRejectionAllowed={*/}
            {/*          props.isTruckApproveRejectionAllowed*/}
            {/*        }*/}
            {/*      />*/}
            {/*    )}*/}
            {/*</div>*/}
            {children}
          </div>
        </div>
      </Fragment>
      {props.truckNomination.isLoading && <ApiSpinner />}

      {/* {props.activityLogs.isLoading === false &&
        props.lineHandling.isLoading === false &&
        props.lineHandling.result === undefined && (
          <NoDataPane onRefresh={onRefresh} />
        )} */}
    </Fragment>
  );
};

export default connect(
  (state: State) => ({
    ...state.activityLogs,
    ...state.general,
    ...state.truckNomination,
    ...state.offlineData,
    ...state.processFlowConfigState,
    ...state.sofView,
  }),
  {
    ...ActivityLogStore.actionCreators,
    ...OfflineDataStore.actionCreators,
    ...ProcessFlowConfigStore.actionCreators,
    ...SofViewStore.actionCreators,
    ...GeneralStore.actionCreators,
    ...TruckNominationStore.actionCreators,
  }
)(NominationHandlingPane as any);
